function devtricker_dom_get_recommendation_account_isAuthorPage(){
    return !!document.querySelector('.recommend-accounts-author-page');
}

function devtricker_dom_get_isToLoadRecommendadAccounts(){
    return !!document.getElementById('recommend-accounts');
}

function devtricker_dom_get_recommendadAccountSection(){
    return document.querySelector('#recommend-accounts');
}

function devtricker_dom_get_recommendation_account_followButtons(){
    return document.querySelectorAll('.who-to-follow button');
}

function devtricker_dom_get_recommendation_account_authorId(){
    return devtricker_dom_get_recommendation_account_isAuthorPage() ? document.querySelector('.author-header').getAttribute('data-author-id') : '0';
}